module.exports = __webpack_public_path__ + "media/images/pic/hero/land-58ebd8237d505b6be475d7e6cfea6f80.webp";